import { css } from 'aphrodite';
import * as React from 'react';
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import { brandPrimary } from '../../styles/colors';
import { baseStyleSheet } from '../../styles/styles';
import { LogoWithTaglineIcon } from '../icons/LogoWithTaglineIcon';
import { styleSheet } from './styles';

export const TopNavLinks = ['home', 'features', 'pricing', 'about'];
export type TopNavLinkName = 'home' | 'features' | 'pricing' | 'about';

interface IProps extends RouteComponentProps<any> {
	activeSection?: TopNavLinkName;
	className?: string;
}

class _TopNav extends React.PureComponent<IProps> {
	public render() {
		const { location } = this.props;
		return (
			<div className={ `top-nav ${ css(styleSheet.container) }` }>
				<div className={ css(styleSheet.spacer) } />
				<div className={ css(styleSheet.fixedContent) }>
					<div className={ css(styleSheet.mainContent) }>
						<NavLink
							className={ css(styleSheet.logoLink) }
							to={ '/home' }
						>
							<LogoWithTaglineIcon
								className={ css(styleSheet.logoLinkIcon) }
							/>
						</NavLink>
						<div className={ css(styleSheet.normalLinks) }>
							{ this.renderTopNavLinks() }
						</div>
						<div className={ css(styleSheet.rightAccessory) }>
							<a
								className={ css(baseStyleSheet.link, styleSheet.signInLink) }
								href='https://secure.levitate.ai'
								target='_blank'
							>
								Sign In
							</a>
							<NavLink
								className={ css(styleSheet.tryButton) }
								location={ location }
								to={ '/pricing' }
							>
								Try Levitate
							</NavLink>
						</div>
					</div>
					<div className={ css(styleSheet.bottomLinks) }>
						{ this.renderTopNavLinks() }
					</div>
				</div>
			</div>
		);
	}

	private renderTopNavLinks() {
		const { location } = this.props;
		return (
			<div className={ css(styleSheet.links) }>
				{
					TopNavLinks.map(x => {
						const lowerRouteName = x.toLowerCase().replace(' ', '');
						const id = `topNavLink-${ lowerRouteName }`;
						return (
							<NavLink
								activeStyle={ { color: brandPrimary } }
								className={ css(styleSheet.link) }
								id={ id }
								key={ id }
								location={ location }
								to={ `/${ lowerRouteName }` }
							>
								{ `${ lowerRouteName.charAt(0).toLocaleUpperCase() }${ lowerRouteName.substring(1) }` }
							</NavLink>
						);
					})
				}
			</div>
		);
	}
}

export const TopNav = withRouter(_TopNav);
